export function fmtCurrency(value: number, currency = "AED"): string {
  return `${currency} ${value.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
}

export function fmtNumber(value: number): string {
  return value.toLocaleString("en-US");
}

export function fmtPercent(value: number, digits = 1): string {
  return `${value.toFixed(digits)}%`;
}

export function fmtDate(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function progressColor(p: number): string {
  if (p >= 75) return "hsl(142,72%,40%)";
  if (p >= 50) return "hsl(210,100%,50%)";
  if (p >= 25) return "hsl(38,92%,50%)";
  return "hsl(0,72%,55%)";
}

export function utilizationColor(p: number): string {
  if (p > 90) return "hsl(0,72%,55%)";
  if (p > 75) return "hsl(38,92%,50%)";
  return "hsl(142,72%,40%)";
}

export function marginColor(p: number): string {
  if (p > 60) return "hsl(142,72%,40%)";
  if (p >= 30) return "hsl(38,92%,50%)";
  return "hsl(0,72%,55%)";
}
